<div class="success-message-overlay" *ngIf="isVisible">
  <div class="success-message-container">
    <!-- Success Header -->
    <div class="success-header">
      <h2 class="success-title">Success! 🎉</h2>
    </div>

    <!-- Success Message -->
    <div class="success-content">
      <p class="success-message">
        Your RFQ has been successfully submitted to <strong>{{ successData.companyName }}</strong>. They have been notified of your quote submission and should review it shortly.
      </p>
    </div>

    <!-- Action Button -->
    <div class="success-actions">
      <button class="btn btn-close" (click)="onCloseClick()">
        Close
      </button>
    </div>
  </div>
</div>
